import { Component } from '@angular/core';
import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { AccessGrantedComponent } from './access-granted/access-granted.component';
import { SendHoursContainerComponent } from './send-hours/send-hours-container/send-hours-container.component';
import { SyncListsComponent } from './sync-lists/sync-lists.component';
import { SendJournalEntryContainerComponent } from './send-journal-entry';
import { QuickbooksRevokeAccessComponent } from './quickbooks-revoke-access/quickbooks-revoke-access.component';
import { AccessRevokedComponent } from './access-revoked/access-revoked.component';
import { CategoriesService } from '../shared';
import { processResolver } from '../efaact-routing/process-resolver';
import { LoggingService } from '../shared/services/logging';
import { QuickBooksConnectComponent } from './quick-books-connect/quick-books-connect.component';

const log = new LoggingService();

@Component({
    template: '<ui-view></ui-view>',
    standalone: false
})
export class QuickbooksContainerComponent {}

export const QuickbooksRoute: Ng2StateDeclaration = {
    name: 'quickbooks',
    url: '/quickbooks',
    redirectTo: 'quickbooks.accessgranted',
    abstract: false,
    data: { requiresAuth: false },
    component: QuickbooksContainerComponent
};
// export const QuickbooksRouteAccessGrantedRoute: Ng2StateDeclaration = {
//     // name: 'quickbooks.**'
//     name: 'quickbooks.accessgranted',
//     url: '/accessgranted/:companyName',
//     // , loadChildren: () => import('./payroll-item.module').then(r => r.IndirectRateModule)
//     data: { requiresAuth: true },
//     resolve: [
//         {
//             token: 'companyName',
//             deps: [Transition],
//             resolveFn: t => t.params().companyName
//         }
//     ],
//     component: AccessGrantedComponent
// };
//http://localhost:4200/efc/quickbooks/accessgranted?code=AB11715717157wE9Gp437bt5m1q17wMC74DgH5hv6CwULTUSF5&state=18ae83aed94aaa1a3fb0cfc38a2e554a1f1ff93a3824c6b370d5647173b08147&realmId=4620816365225809380
export const QuickbooksRouteAccessGrantedRoute: Ng2StateDeclaration = {
    // name: 'quickbooks.**'
    name: 'quickbooks.accessgranted',
    url: '/accessgranted?code&state&realmId',
    params: {
        code: { value: null, squash: true },
        state: { value: null, squash: true },
        realmId: { value: null, squash: true }
    },
    // , loadChildren: () => import('./payroll-item.module').then(r => r.IndirectRateModule)
    data: { requiresAuth: true },
    resolve: [
        {
            token: 'code',
            deps: [Transition],
            resolveFn: t => t.params().code
        },
        {
            token: 'state',
            deps: [Transition],
            resolveFn: t => t.params().state
        },
        {
            token: 'realmId',
            deps: [Transition],
            resolveFn: t => t.params().realmId
        }
    ],
    component: AccessGrantedComponent
};
export const QuickbooksConnectRoute: Ng2StateDeclaration = {
    // name: 'quickbooks.**'
    name: 'quickbooksauth',
    url: '/quickbooksauth',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.IndirectRateModule)
    data: { requiresAuth: true },
    component: QuickBooksConnectComponent
};

export const QuickbooksRouteAccessRevokedRoute: Ng2StateDeclaration = {
    // name: 'quickbooks.**'
    name: 'qbaccessrevoked',
    url: '/qbaccessrevoked',

    // , loadChildren: () => import('./payroll-item.module').then(r => r.IndirectRateModule)
    data: { requiresAuth: false },
    params: { process: {} },
    resolve: [
        {
            token: 'process',
            deps: [Transition, CategoriesService],
            resolveFn: processResolver
        }
    ],
    component: AccessRevokedComponent
};
export const QuickbooksImportListsRoute: Ng2StateDeclaration = {
    // name: 'quickbooks.**'
    name: 'qbsynclists',
    url: '/qbsynclists',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.IndirectRateModule)
    data: { requiresAuth: true },
    component: SyncListsComponent
};
export const QuickbooksSendHoursRoute: Ng2StateDeclaration = {
    // name: 'quickbooks.**'
    name: 'qbsendhours',
    url: '/qbsendhours',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.IndirectRateModule)
    data: { requiresAuth: true },
    component: SendHoursContainerComponent
};
export const QuickbooksJournalEntryRoute: Ng2StateDeclaration = {
    // name: 'quickbooks.**'
    name: 'qbsendjournalentry',
    url: '/qbsendjournalentry',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.IndirectRateModule)
    data: { requiresAuth: true },
    component: SendJournalEntryContainerComponent
};
export const QuickbooksRevokeAccessRoute: Ng2StateDeclaration = {
    // name: 'quickbooks.**'
    name: 'qbrevoke',
    url: '/qbrevoke',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.IndirectRateModule)
    data: { requiresAuth: true },
    component: QuickbooksRevokeAccessComponent
};
export const QuickbooksProcessPeriodRoute: Ng2StateDeclaration = {
    // name: 'quickbooks.**'
    name: 'qbprocessperiod',
    // url: '/qbprocessperiod',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.IndirectRateModule)
    data: { requiresAuth: true },
    redirectTo: 'period.reprocessing'
};
